import { UserTitle } from '@mkp/user/models';
import { createActionGroup, props } from '@ngrx/store';
import { UpdateUser } from '@mkp/user/models';

export interface IncompleteUserPayload extends Omit<UpdateUser, 'title'> {
  title: UserTitle;
  firstName: string;
  lastName: string;
  gtcAcceptedAt: string;
}

export const incompleteUserActions = createActionGroup({
  source: 'Incomplete User Onboarding',
  events: {
    'Update User': props<{ user: IncompleteUserPayload }>(),
  },
});
